/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// const app = new Vue({
//     el: '#app',
// });
import { CountUp } from 'countup.js';
window.onload = function() {
    const allCountNum = $('.counter_num');
    let h = $(window).innerHeight();
    let windowTop = $(window).scrollTop();
    const offsetTop =$('.counter_num').offset().top;
    let remove = true;
    let option= {
        duration: 3,
        decimalPlaces: 1
    };
    allCountNum.each(function(index) {
        const value = $(allCountNum[index]).data('top');
        var allCountNumAnimation = new CountUp(allCountNum[index],value,option);
        if ((windowTop + h) - offsetTop > 0) {
            allCountNumAnimation.start();
            remove = false;
        }
    });
    $(window).on('scroll', function () {
        let offsetTop1 = $('.counter_num').offset().top;
        let windowTop1 = $(window).scrollTop();
        let h1 = $(window).innerHeight();
        if ((windowTop1 + h1) - offsetTop1 > 0 && remove == true) {
            allCountNum.each(function(index) {
                var value = parseFloat($(allCountNum[index]).data('top'));
                var allCountNumAnimation1 = new CountUp(allCountNum[index],value,option);
                allCountNumAnimation1.start();
            });
            remove = false;
        } else {
            // $(window).on('scroll');
        }
    });
}

import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init({
    anchorPlacement: 'center-bottom',
    // delay: 100,
    duration: 800,
    once: true,
});


import Swiper from 'swiper';

var mySwiper = new Swiper ('.home_swiper', {
    effect: 'fade',
    // fadeEffect: {
    //     crossFade: true
    // },
    speed: 1000,
    autoplay: {
        delay: 4000,
    }
});

var mySwiper3 = new Swiper ('.client_swiper', {
    speed: 500,
    slidesPerView: 2,
    spaceBetween : 10,
    breakpoints: {
        960:{
            slidesPerView: 6,
            spaceBetween: 30
        }
    },
    pagination: {
        el: '.pagination1',
        clickable: true,
    },
});
